module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-4.5b84cfd2.svg";